import React, { useState } from 'react';
import {
  Box,
  Typography,
  List,
  ListItem,
  ListItemText,
  useMediaQuery,
} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import newCategories from './newCategories';

const CATALOGUE_ID = '64ef4986d269731b208134bf';
const CATALOGUE_BASE = `/market/categoria/${CATALOGUE_ID}?nombre=MARKET`;

/** Mapear el “filter” viejo a query params nuevos */
function buildQueryFromFilter(filter = {}) {
  const sp = new URLSearchParams();
  if (filter.Categoria) sp.set('cat', filter.Categoria);
  if (filter.Subcategoria) sp.set('subcat', filter.Subcategoria);
  if (filter.Marca) sp.set('marca', filter.Marca);
  if (filter.Termino) sp.set('q', filter.Termino);
  const qs = sp.toString();
  return qs ? `${CATALOGUE_BASE}&${qs}` : CATALOGUE_BASE;
}

const MegaMenu = () => {
  const navigate = useNavigate();
  const isMobile = useMediaQuery('(max-width:900px)');
  const [openIndex, setOpenIndex] = useState(null);
  const [hoverIndex, setHoverIndex] = useState(null);

  const isGangasTitle = (title) => /ganga/i.test(title);

  const handleNavigateCatalogue = (filter) => {
    navigate(buildQueryFromFilter(filter));
  };

  const toggleMenu = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  const handleMouseEnter = (index, title) => {
    if (!isMobile && !isGangasTitle(title)) setHoverIndex(index);
  };

  const handleMouseLeave = () => {
    if (!isMobile) setHoverIndex(null);
    if (!isMobile) setHoverIndex(null);
  };

  return (
    <Box sx={{ backgroundColor: '#fff', position: 'relative', zIndex: 10 }}>
      <Box sx={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center', gap: 3 }}>
        {newCategories.map((section, index) => {
          const isMarcas = section.title === 'MARCAS';
          const isGangas = isGangasTitle(section.title);
          const hasContent = !isGangas && section.categories && section.categories.length > 0;

          const isOpenMobile = openIndex === index;
          const isOpenDesktop = hoverIndex === index;

          return (
            <Box
              key={index}
              sx={{ position: 'relative' }}
              onMouseEnter={() => handleMouseEnter(index, section.title)}
              onMouseLeave={handleMouseLeave}
            >
              <Typography
                onClick={() => {
                  if (isGangas) {
                    navigate('/ofertas');
                  } else if (!isMarcas) {
                    // si el propio "section" tiene filter, lo usamos
                    if (section.filter) handleNavigateCatalogue(section.filter);
                  } else {
                    // abrir en mobile el dropdown de MARCAS
                    if (isMobile) toggleMenu(index);
                  }
                }}
                sx={{
                  cursor: (isGangas || hasContent || isMarcas) ? 'pointer' : 'default',
                  fontWeight: 400,
                  px: 2,
                  py: 1,
                  ...(isGangas && { '&:hover': { color: '#D32F2F', fontWeight:"700" } }),
                }}
              >
                {section.title}
              </Typography>

              {/* Dropdown de MARCAS */}
              {isMarcas && section.marcasArray?.length > 0 ? (
                <Box
                  className="dropdown"
                  sx={{
                    display: isMobile
                      ? isOpenMobile ? 'block' : 'none'
                      : isOpenDesktop ? 'block' : 'none',
                    position: isMobile ? 'static' : 'absolute',
                    top: isMobile ? 'auto' : '100%',
                    left: 0,
                    backgroundColor: '#fff',
                    boxShadow: 3,
                    p: 2,
                    minWidth: 200,
                    maxHeight: '40vh',
                    overflowY: 'auto',
                    zIndex: 5,
                  }}
                >
                  <List dense disablePadding>
                    {section.marcasArray.map((marca, i) => (
                      <ListItem
                        key={i}
                        sx={{ pl: 0, cursor: 'pointer' }}
                        onClick={() => {
                          const url = `${CATALOGUE_BASE}&marca=${encodeURIComponent(marca)}`;
                          navigate(url);
                        }}
                      >
                        <ListItemText primary={marca} />
                      </ListItem>
                    ))}
                  </List>
                </Box>
              ) : hasContent ? (
                // 👇 NO renderizamos dropdown si es Gangas (hasContent ya lo excluye)
                <Box
                  className="dropdown"
                  sx={{
                    display: isMobile
                      ? isOpenMobile ? 'block' : 'none'
                      : isOpenDesktop ? 'block' : 'none',
                    position: isMobile ? 'static' : 'absolute',
                    top: isMobile ? 'auto' : '100%',
                    left: 0,
                    backgroundColor: '#fff',
                    boxShadow: 3,
                    p: 2,
                    minWidth: 500,
                    minWidth: 500,
                    zIndex: 5,
                  }}
                >
                  <Box
                    sx={{
                      display: 'grid',
                      gridTemplateColumns: 'repeat(2, 1fr)',
                      gap: 2,
                    }}
                  >
                    {section.categories.map((cat, catIndex) => (
                      <Box key={catIndex}>
                        <Typography
                          variant="subtitle1"
                          fontWeight="bold"
                          gutterBottom
                          sx={{ cursor: 'pointer' }}
                          onClick={() => handleNavigateCatalogue(cat.filter)}
                        >
                          {cat.name}
                        </Typography>

                        {cat.subcategories?.length > 0 && (
                          <List dense disablePadding>
                            {cat.subcategories.map((sub, subIndex) => (
                              <ListItem
                                key={subIndex}
                                sx={{ pl: 0, cursor: 'pointer' }}
                                onClick={() => handleNavigateCatalogue(sub.filter)}
                              >
                                <ListItemText primary={sub.label} />
                              </ListItem>
                            ))}
                          </List>
                        )}
                      </Box>
                    ))}
                  </Box>
                </Box>
              ) : null}
            </Box>
          );
        })}
      </Box>
    </Box>
  );
};

export default MegaMenu;
